import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

function Spinner({ className, size = "default", ...props }) {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12",
  };

  return (
    <Loader2
      className={cn("animate-spin text-coral", sizeClasses[size], className)}
      {...props}
    />
  );
}

function SpinnerOverlay({ children, spinning = false, className, size }) {
  if (!spinning) return children;

  return (
    <div className={cn("relative", className)}>
      {children}
      <div className="absolute inset-0 flex items-center justify-center bg-white/60 z-10">
        <Spinner size={size} />
      </div>
    </div>
  );
}

export { Spinner, SpinnerOverlay };
